"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InitializeCart_1 = require("./InitializeCart");
exports.default = InitializeCart_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/cart-initializer/CartInit/index.js
// module id = 380
// module chunks = 8